<template>
    <b-row class="mt-4">
        <div class="position-fixed d-none d-lg-block col-2" style="z-index: 10">
            <b-list-group v-b-scrollspy class="table-of-contents">
                <b-list-group-item href="#main-menus">Main Menus</b-list-group-item>
                <b-list-group-item href="#save-files">Save Files</b-list-group-item>
                <b-list-group-item href="#character-menu">Character Menu</b-list-group-item>
                <b-list-group-item href="#options">Options</b-list-group-item>
                <b-list-group-item href="#interaction-studio">Interaction Studio</b-list-group-item>
                <b-list-group-item href="#vr-tools">VR Tools</b-list-group-item>
            </b-list-group>
        </div>

        <div class="col-2 d-none d-lg-block"></div>
        <div class="col-12 col-lg-9 ml-3 guide-list">
            <h4 id="main-menus" class="mt-0">Main Menus</h4>

        </div>
    </b-row>
</template>

<script>
    export default {
        name: "Menus"
    }
</script>
